import './ProgressLoading.scss'

import { Button } from '@sainsburys-tech/fable'
import React from 'react'

interface ProgressLoadingProps {
  testid?: string
  message?: string
  progress?: number // 0-100, if not provided, shows indeterminate animation
  subMessage?: string // Optional secondary message
}

const ProgressLoading: React.FC<ProgressLoadingProps> = ({
  testid,
  message = 'Loading...',
  progress,
  subMessage,
}) => {
  return (
    <div className='progress-loading' data-testid={testid}>
      <div className='progress-loading__container'>
        <div className='progress-loading__bar-container'>
          <div
            className={`progress-loading__bar ${progress === undefined ? 'progress-loading__bar--indeterminate' : ''}`}
            style={progress !== undefined ? { width: `${progress}%` } : {}}
          />
        </div>
        <div className='progress-loading__message'>{message}</div>
        {subMessage && (
          <div className='progress-loading__sub-message'>{subMessage}</div>
        )}
        <Button
          className='progress-loading__refresh-btn'
          variant='secondary'
          isFullWidth={false}
          type='button'
          onClick={() => {
            window.location.href = window.location.origin
          }}
          testid='reload-button'
        >
          Reload
        </Button>
      </div>
    </div>
  )
}

export default ProgressLoading
